import { Fragment } from 'react';

import EditIcon from '@usas/ui-web/components/icons/EditIcon';
import DeleteIcon from '@usas/ui-web/components/icons/DeleteIcon';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const LargeGrid = ({ state, gridState, onEdit, onDelete }) => (
  <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
    <thead>
      <tr>
        <th>Min # Athletes</th>
        <th>Max # Athletes</th>
        <th>Allowed # Deck Passes</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {state.isObjLoaded !== true
        ? (<Fragment>
          {state.isObjLoading === true ?
            <tr>
              <td colSpan="4">Loading...</td>
            </tr> :
            <tr>
              <td colSpan="4">No Deck Pass Rules</td>
            </tr>
          }
        </Fragment>
        ) : state.objData.omeMeetCoachPass?.length > 0 &&
          gridState.sortedCoachGridData.length > 0 ?
          gridState.sortedCoachGridData.map((coach, i) => (
            < tr key={coach.omeMeetCoachPassId || i} >
              <td>{coach.minSwimmers >= 0 ? coach.minSwimmers : ''}</td>
              <td>{coach.maxSwimmers >= 0 ? coach.maxSwimmers : ''}</td>
              <td>{coach.coachPasses >= 0 ? coach.coachPasses : ''}</td>
              <td>
                {onEdit &&
                  <button className={global.IconButtonMargin} type="button" onClick={(e) => onEdit(e, coach.omeMeetCoachPassId)}>
                    <EditIcon />
                  </button>}
                {onDelete &&
                  <button className={global.IconButtonMargin} type="button" onClick={(e) => onDelete(e, coach)}>
                    <DeleteIcon />
                  </button>}
              </td>
            </tr>)
          ) : (
            <tr>
              <td colSpan="4">No Deck Pass Rules</td>
            </tr>
          )
      }
    </tbody>
  </table >
);

const SmallGrid = ({ state, gridState, onEdit, onDelete }) => (
  <div className={[global.SmallTable, 'hidden-md hidden-lg'].join(' ')}>
    {state.isObjLoaded !== true
      ? (
        <div className={global.SmallTableRow}>
          <div className={global.SmallTableRowHead}>&nbsp;</div>
          <div className={global.SmallTableRowInfo}>
            {state.isObjLoading === true
              ? <div className={global.SmallTableRowLabels}>Loading...</div>
              : <div className={global.SmallTableRowLabels}>No Deck Pass Rules</div>
            }
          </div>
        </div>
      )
      : state.objData.omeMeetCoachPass?.length > 0 &&
        gridState.sortedCoachGridData.length > 0 ?
        gridState.sortedCoachGridData.map((coach, i) => (
          <div className={global.SmallTableRow} key={coach.omeMeetCoachPassId || i}>
            <div className={global.SmallTableRowHead}>
              <span className='hidden-xs'>Deck Pass Rule</span>&nbsp;
              {onDelete &&
                <button className={global.IconButton} type="button" onClick={(e) => onDelete(e, coach)}>
                  <DeleteIcon />
                </button>}
              {onEdit &&
                <button className={global.IconButtonMobileMargin} type="button" onClick={(e) => onEdit(e, coach.omeMeetCoachPassId)}>
                  <EditIcon />
                </button>}
            </div>
            <div className={global.SmallTableRowInfo}>
              <div className='row'>
                <div className={['col-xs-9 col-sm-6', global.SmallTableRowLabels].join(' ')}>Min # Athletes</div>
                <div className={['col-xs-3 col-sm-6', global.SmallTableRowData].join(' ')}>{coach.minSwimmers >= 0 ? coach.minSwimmers : <span>&nbsp;</span>}</div>
                <div className={['col-xs-9 col-sm-6', global.SmallTableRowLabels].join(' ')}>Max # Athletes</div>
                <div className={['col-xs-3 col-sm-6', global.SmallTableRowData].join(' ')}>{coach.maxSwimmers >= 0 ? coach.maxSwimmers : <span>&nbsp;</span>}</div>
                <div className={['col-xs-9 col-sm-6', global.SmallTableRowLabels].join(' ')}>Allowed # Deck Passes</div>
                <div className={['col-xs-3 col-sm-6', global.SmallTableRowData].join(' ')}>{coach.coachPasses >= 0 ? coach.coachPasses : <span>&nbsp;</span>}</div>
              </div>
            </div>
          </div>
        )
        )
        : (
          <div className={global.SmallTableRow}>
            <div className={global.SmallTableRowHead}>&nbsp;</div>
            <div className={global.SmallTableRowInfo}>
              <div className={global.SmallTableRowLabels}>No Deck Pass Rules</div>
            </div>
          </div>
        )}
  </div >
);

const OmeEligibilityCoachPassesGrid = ({ omeMeetState, gridState, onEdit, onDelete }) => (
  <Fragment>
    <LargeGrid state={omeMeetState} gridState={gridState} onEdit={onEdit} onDelete={onDelete} />
    <SmallGrid state={omeMeetState} gridState={gridState} onEdit={onEdit} onDelete={onDelete} />
  </Fragment>
);

export default OmeEligibilityCoachPassesGrid;